export const common = {
  nav: {
    home: 'الرئيسية',
    about: 'من نحن',
    services: 'خدماتنا',
    team: 'فريقنا',
    contact: 'تواصل معنا',
  },
  hero: {
    title: 'مكتب المحامية غدير سالم أشكناني',
    subtitle: 'للمحاماة والاستشارات القانونية',
    description: 'خبرة قانونية تمتد لأكثر من 8 سنوات في تقديم حلول قانونية متكاملة',
    cta: 'احجز استشارة',
    learn: 'اعرف المزيد',
  },
  stats: {
    experience: 'سنوات خبرة',
    cases: 'قضية ناجحة',
    clients: 'عميل راضٍ',
    rate: 'نسبة النجاح',
  },
  about: {
    title: 'من نحن',
    subtitle: 'التميز القانوني والاحترافية',
    description: 'يُعد مكتب المحامية غدير سالم أشكناني للمحاماة والاستشارات القانونية من المكاتب القانونية الرائدة في دولة الكويت، حيث تأسس عام 2018 ليكون وجهة قانونية موثوقة لتقديم حلول قانونية متكاملة تقوم على الاحتراف، والدقة، والالتزام بأعلى المعايير المهنية.',
    founder: 'يعمل المكتب تحت إشراف وقيادة المحامية/ غدير سالم أشكناني، مؤسسة المكتب، وهي من الكفاءات القانونية المتميزة في مجال المحاماة، وتحمل درجة الماجستير في القانون، وتمتلك خبرة عملية تمتد لأكثر من ثماني سنوات في الترافع أمام مختلف درجات المحاكم، وتقديم الاستشارات القانونية المتخصصة للأفراد والشركات.',
    commitment: 'ويحرص المكتب على تقديم خدماته القانونية إلى المواطنين والمقيمين من مختلف الجنسيات داخل دولة الكويت وخارجها، واضعًا نصب عينيه تحقيق أفضل النتائج القانونية لعملائه، من خلال الدراسة المتعمقة لكل قضية، ووضع استراتيجيات قانونية مدروسة، والمتابعة المستمرة حتى الوصول إلى الحلول القانونية المثلى.',
    services: 'كما يقدم المكتب خدماته باللغتين العربية والإنجليزية، بما يلبي احتياجات العملاء المحليين والدوليين، ويواكب تطورات البيئة القانونية، مع الالتزام الكامل بسرية المعلومات وحماية مصالح العملاء.',
    partner: 'إن مكتب المحامية غدير سالم أشكناني لا يقتصر دوره على الترافع أو تقديم الاستشارات فحسب، بل يسعى إلى أن يكون شريكًا قانونيًا موثوقًا لعملائه، من خلال تقديم دعم قانوني شامل يعزز المراكز القانونية ويحمي الحقوق بثقة واحتراف.',
  },
  services: {
    title: 'خدماتنا القانونية',
    subtitle: 'حلول قانونية متكاملة',
    description: 'يقدم مكتب المحامية غدير سالم أشكناني للمحاماة والاستشارات القانونية خدمات قانونية متكاملة تغطي مختلف فروع القانون، مع الالتزام بالدقة، والاحتراف، وحسن إدارة القضايا بما يحقق أفضل النتائج لعملائنا.',
    criminal: {
      title: 'القضايا الجزائية',
      description: 'الدفاع في جميع أنواع القضايا الجزائية بما في ذلك الجنايات والجنح',
    },
    civil: {
      title: 'الدعاوى المدنية والتجارية',
      description: 'تمثيل قانوني شامل في كافة صور الدعاوى المدنية والتجارية',
    },
    labor: {
      title: 'الدعاوى العمالية',
      description: 'حل منازعات العمل وحماية حقوق العمال وأصحاب العمل',
    },
    administrative: {
      title: 'القضاء الإداري',
      description: 'الطعن على القرارات الإدارية أمام المحاكم المختصة',
    },
    family: {
      title: 'دعاوى الأسرة',
      description: 'قضايا الأحوال الشخصية وفقًا لأحكام الفقه الجعفري والسني',
    },
    arbitration: {
      title: 'التحكيم التجاري',
      description: 'تسوية المنازعات البديلة والتحكيم التجاري الدولي',
    },
  },
  team: {
    title: 'فريقنا',
    subtitle: 'فريق من الخبراء القانونيين',
    founder: {
      name: 'د. غدير أشكناني',
      role: 'المؤسس والمدير التنفيذي',
      description: 'محامية متخصصة في القانون التجاري والشركات مع خبرة تزيد عن 8 سنوات في تقديم الاستشارات القانونية للشركات الكبرى والمتوسطة. حاصلة على ماجستير في القانون التجاري الدولي.',
    },
    consultant1: {
      name: 'المحامي أحمد الخالدي',
      role: 'مستشار قانوني أول',
      description: 'متخصص في قانون العمل والتأمينات الاجتماعية مع خبرة 10 سنوات في تمثيل الشركات والموظفين في النزاعات العمالية.',
    },
    consultant2: {
      name: 'المحامي فيصل العتيبي',
      role: 'مستشار قانوني',
      description: 'خبير في التحكيم التجاري وحل النزاعات مع سجل حافل في الفصل في القضايا التجارية المعقدة محلياً ودولياً.',
    },
    coordinator1: {
      name: 'المحامي خالد المطيري',
      role: 'منسق الإجراءات القضائية',
      description: 'متخصص في متابعة الإجراءات القضائية وإدارة القضايا أمام المحاكم الكويتية بكفاءة عالية.',
    },
    coordinator2: {
      name: 'المحامي سعد الرشيدي',
      role: 'منسق قانوني',
      description: 'خبير في إعداد المذكرات القانونية والعقود مع اهتمام دقيق بالتفاصيل القانونية والإجرائية.',
    },
    lawyer1: {
      name: 'المحامية نورة السالم',
      role: 'محامية أحوال شخصية',
      description: 'متخصصة في قضايا الأحوال الشخصية والأسرة مع خبرة 6 سنوات في التعامل مع القضايا الحساسة بسرية واحترافية.',
    },
    lawyer2: {
      name: 'المحامي عبدالله الدوسري',
      role: 'محامي عقارات',
      description: 'خبير في القانون العقاري والتطوير العقاري مع خبرة واسعة في صياغة عقود البيع والإيجار والتطوير.',
    },
    lawyer3: {
      name: 'المحامية مريم الهاجري',
      role: 'محامية ملكية فكرية',
      description: 'متخصصة في حماية الملكية الفكرية والعلامات التجارية مع خبرة في تسجيل وحماية حقوق الملكية الفكرية.',
    },
    paralegal1: {
      name: 'فاطمة العنزي',
      role: 'مساعدة قانونية',
      description: 'متخصصة في البحث القانوني وإعداد المستندات مع خبرة 4 سنوات في دعم الفريق القانوني.',
    },
    paralegal2: {
      name: 'محمد البلوشي',
      role: 'مساعد قانوني',
      description: 'خبير في إدارة الملفات القانونية والتنسيق مع الجهات الحكومية لإنجاز المعاملات بسرعة وكفاءة.',
    },
  },
  contact: {
    title: 'تواصل معنا',
    subtitle: 'نحن هنا لمساعدتك',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    message: 'رسالتك',
    send: 'إرسال',
    info: 'معلومات التواصل',
    address: 'الكويت',
  },
  booking: {
    title: 'احجز استشارة قانونية',
    subtitle: 'احجز موعدك الآن',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    caseType: 'نوع القضية',
    date: 'تاريخ الموعد',
    time: 'وقت الموعد',
    details: 'تفاصيل القضية',
    submit: 'تأكيد الحجز',
    selectType: 'اختر نوع القضية',
    selectTime: 'اختر الوقت',
  },
  footer: {
    description: 'مكتب قانوني رائد في دولة الكويت يقدم حلول قانونية متكاملة منذ عام 2018',
    quickLinks: 'روابط سريعة',
    services: 'الخدمات',
    legal: 'قانوني',
    privacy: 'سياسة الخصوصية',
    terms: 'الشروط والأحكام',
    rights: 'جميع الحقوق محفوظة',
    newsletter: 'اشترك في نشرتنا',
    subscribe: 'اشتراك',
    emailPlaceholder: 'بريدك الإلكتروني',
  },
};